import { render, staticRenderFns } from "./add-rlist-user.html?vue&type=template&id=5353f637&scoped=true&"
import script from "./add-rlist-user.js?vue&type=script&lang=js&"
export * from "./add-rlist-user.js?vue&type=script&lang=js&"
import style0 from "./add-rlist-user.scss?vue&type=style&index=0&id=5353f637&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5353f637",
  null
  
)

export default component.exports